import Button from "@/components/Button";
import ChangePriceAlert from "@/components/ChangePriceAlert";
import Checkbox from "@/components/Checkbox";
import Column from "@/components/Column";
import Columns from "@/components/Columns";
import Form from "@/components/Form";
import Input from "@/components/Input";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";
import ShortFlowLayout from "@/components/ShortFlow/ShortFlowLayout";
import Text from "@/components/Text";
import { useShortFlowPersonalData } from "./hooks/useShortFlowPersonalData";

export function ShortFlowPersonalData() {
  const {
    showChangePriceAlert,
    currentPrice,
    personalDataSchema,
    saleId,
    bind,
    IsEmailValid,
    phoneBlock,
    cpf,
    isLoading,
    userDataNotFound,
    fullName,
    birthDate,
    motherName,
    formIsValid,
    pageConfig,
    tel,
    autorizarContato,
    setEmail,
    handleOnSubmit,
    handleUserJourney,
    setAutorizarContato,
    setTel,
    handleOnBlurUserJourney,
    setMotherName,
    setCpf,
    setFullName,
    setBirthDate,
    setShowChangePriceAlert,
  } = useShortFlowPersonalData();

  return (
    <ShortFlowLayout>
      <SEO
        title="Dados Pessoais"
        description="Adicione seus dados pessoais para comprar seu plano TIM"
      />
      {showChangePriceAlert && (
        <ChangePriceAlert
          setShowChangePriceAlert={setShowChangePriceAlert}
          currentPrice={currentPrice}
        />
      )}
      <Column size={12}>
        <PageHeader
          title="Olá! Preencha seus dados para continuar."
          dataIcTitle="sec-omega-comunicacao"
        />
      </Column>
      <Columns
        as={Form}
        className="pt-6"
        alignItems="start"
        justifyContent="center"
        validationSchema={personalDataSchema}
        onSubmit={handleOnSubmit}
      >
        <Column size={12} className="pb-6">
          <input type="hidden" id="user_prefs" name="user_prefs" />
          <input type="hidden" id="user_prefs2" name="user_prefs2" />
          <Input
            name="email"
            inputMode="email"
            autoComplete="email"
            placeholder="E-mail"
            disabled={!!saleId}
            helperText="Receba sua fatura neste e-mail ou acesse o App Meu TIM"
            {...bind}
            ref={bind.ref as React.RefObject<HTMLInputElement>}
            onBlur={() => {
              const v = bind.onBlur();
              setEmail(v);
              if (IsEmailValid) {
                handleUserJourney("email", v);
              }
            }}
          />
        </Column>

        <Column size={12} className="pb-4">
          <Input
            mask="99 99999-9999"
            name="tel"
            type="tel"
            value={tel}
            label="Número atual"
            disabled={!!saleId || !!phoneBlock}
            placeholder="11 99999-9999"
            onChange={(e) => setTel(e.target.value)}
            onBlur={(e) => {
              setTel(e.target.value);
              handleOnBlurUserJourney(e.target.name, e.target.value);
            }}
          />
        </Column>
        <Column size={12} className="pb-4">
          <Checkbox
            name="autorizarContato"
            checked={autorizarContato}
            disabled={!!saleId}
            onChange={(e) => {
              setAutorizarContato(e.target.checked);
              handleUserJourney(e.target.name, e.target.checked);
            }}
          >
            <Text size="xs" className="leading-tight">
              Aceito receber comunicação para continuar minha compra.
            </Text>
          </Checkbox>
        </Column>
        <Column size={12} className="pb-4">
          <Input
            type="tel"
            mask="999.999.999-99"
            name="cpf"
            label="CPF"
            value={cpf}
            disabled={!!saleId}
            placeholder="000.000.000-00"
            loading={isLoading}
            onChange={(e) => {
              setCpf(e.target.value);
              handleOnBlurUserJourney(e.target.name, e.target.value);
            }}
            onBlur={(e) => setCpf(e.target.value)}
          />
        </Column>

        {userDataNotFound && (
          <>
            <Column size={12} className="pb-6">
              <Input
                name="fullName"
                label="Nome Completo"
                placeholder="Nome Completo"
                onChange={(e) => setFullName(e.target.value)}
                onBlur={(e) => {
                  setFullName(e.target.value);
                  handleOnBlurUserJourney(e.target.name, e.target.value);
                }}
                value={fullName}
                disabled={!!saleId}
              />
            </Column>

            <Column size={12} className="pb-6">
              <Input
                type="tel"
                mask="99/99/9999"
                name="birthDate"
                label="Data de Nascimento"
                placeholder="24/07/2000"
                value={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
                onBlur={(e) => {
                  setBirthDate(e.target.value);
                  handleOnBlurUserJourney(e.target.name, e.target.value);
                }}
                disabled={!!saleId}
              />
            </Column>

            <Column size={12} className="pb-6">
              <Input
                name="motherName"
                label="Nome da Mãe"
                placeholder="Nome da Mãe"
                value={motherName}
                onChange={(e) => setMotherName(e.target.value)}
                onBlur={(e) => {
                  setMotherName(e.target.value);
                  handleOnBlurUserJourney(e.target.name, e.target.value);
                }}
                disabled={!!saleId}
              />
            </Column>
          </>
        )}

        <Column size={12}>
          <Button
            type="submit"
            large
            helperText={!formIsValid ? "todos os campos são obrigatórios" : ""}
            disabled={isLoading || !formIsValid}
          >
            {!formIsValid ? "Preencha os campos para continuar" : "Continuar"}
          </Button>
        </Column>

        <Column size={12} className="mt-8">
          <Button
            type="button"
            kind="secondary"
            large
            to={phoneBlock ? "/smart-page" : pageConfig.prevRoute}
            data-ic-trigger="sec-omega-voltar"
          >
            Voltar
          </Button>
        </Column>
      </Columns>
    </ShortFlowLayout>
  );
}
